<template>
    <div class="people_position">
        <template v-if="type === 'eval' || type === 'test'">
            <div
                class="position_item mb8"
                v-for="(i,index) in posiList"
                :key="index"
                v-if="list[i.value || i] && list[i.value || i].length"
                :class="group?'':'group'"
            >
                <!--球员title-->
                <p v-if="group" class="position_tit mb16 SysFontM">{{i['label'+$lang]}}</p>
                <!--列表-->
                <div class="list mt15" :class="group?'':'group'">
                    <div
                        class="list_item player_item"
                        v-for="item in list[i.value || i]"
                        :key="item.id"
                        @click="clickItem(item)"
                        :style="{height:itemHeight}"
                    >
                        <span class="number AkrobatM">{{item.number}}</span>
                        <cl-avatar
                            class="mr16"
                            style="filter:drop-shadow(0px 6px 8px rgba(54, 99, 225, 0.16))"
                            :src="item.avatar"
                            width="40"
                            height="40"
                        ></cl-avatar>
                        <div class="item_details">
                            <p class="name">
                                <span class="Text_Over SysFontM">{{item['name'+$lang]}}</span>
                            </p>
                            <!-- 评估 -->
                            <span v-if="isTime && type === 'eval'" class="time mt8">
                                <cl-svg-icon class="mr6 time_icon" icon-class="time"></cl-svg-icon>
                                <span
                                    class="AkrobatM"
                                >{{item.latestReportTime ? $utils.formatTime('YYYY/MM/DD', item.latestReportTime) : $nullText}}</span>
                            </span>
                            <!-- 体测 -->
                            <span v-if="isTime && type === 'test'" class="time mt8">
                                <cl-svg-icon class="mr3" style="font-size: 14px" icon-class="time"></cl-svg-icon>
                                <span
                                    class="AkrobatM"
                                >{{item.latestPhysicalTime ? $utils.formatTime('YYYY/MM/DD', item.latestPhysicalTime) : $nullText}}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="type === 'player-video'">
            <!-- 球员视频统计item项 -->
            <div
                class="position_item player_video mt8"
                v-for="item in positionList"
                :key="item.value"
            >
                <p
                    v-if="list[item.value] && list[item.value].length"
                    class="position_tit mb16 SysFontM"
                >{{ item['label'+$lang] || defaultText }}</p>
                <div class="player_list mt15">
                    <div
                        class="player_item"
                        v-for="i in list[item.value]"
                        :key="i.id"
                        @click="clickItem(i)"
                    >
                        <span class="number AkrobatM">{{ i.number }}</span>
                        <cl-avatar :src="i.avatar" width="40" height="40" round></cl-avatar>
                        <div class="player_info">
                            <p class="name mb3">
                                <span
                                    class="Text_Over SysFontM"
                                >{{ i['name'+$lang] || defaultText }}</span>
                            </p>
                            <p class="video_number">
                                <cl-svg-icon
                                    class="mr11 video_icon"
                                    icon-class="player_video_number"
                                ></cl-svg-icon>
                                <span class="AkrobatM">{{ i.clipNumbers || 0 }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="type === 'eval-staff'">
            <div class="position_item mb10">
                <!--列表-->
                <div class="list">
                    <div
                        class="list_item"
                        v-for="item in list"
                        :key="item.id"
                        @click="clickItem(item)"
                        :style="{height:itemHeight}"
                    >
                        <cl-avatar
                            class="mr16"
                            style="filter:drop-shadow(0px 6px 8px rgba(54, 99, 225, 0.16))"
                            :src="item.avatar"
                            width="40"
                            height="40"
                        ></cl-avatar>
                        <div class="item_details">
                            <p class="name mb8">
                                <span class="Text_Over SysFontM">{{item['name'+$lang] || item['name'+$lang2]}}</span>
                            </p>
                            <p class="group_position mb8">
                                <span
                                    class="Text_Over"
                                >{{ item.title || item.campJob || $nullText }}</span>
                            </p>
                            <!-- 评估 -->
                            <span v-if="isTime" class="time bg">
                                <cl-svg-icon class="mr6 time_icon" icon-class="time"></cl-svg-icon>
                                <span
                                    class="AkrobatM fs14"
                                >{{item.latestReportTime ? $utils.formatTime('YYYY/MM/DD', item.latestReportTime) : $nullText}}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
/**
 * ComponentName: people positions
 * Created Date:2022/5/13
 * Author: zhangch
 * Modify: haogang·du 2022/5/17
 * 组件说明：
 * 这组组件是球员、教练员列表组件，支持是否按职位区分
 * eg:
 *     <cl-people-position-list></cl-people-position-list>
 */
export default {
    name: 'cl-people-position-list',
    data () {
        return {
            defaultText: '--',  // 默认占位符
            posiList: []
        };
    },
    props: {
        type: {
            type: String,
            default: 'eval'
        },
        list: {     // 展示的数据
            type: Object | Array,
            default: () => { }
        },
        positionList: {     // 职位项
            type: Array,
            default: () => []
        },
        isTime: {
            type: Boolean,
            default: true
        },
        // 卡片的高度
        itemHeight: {
            type: String,
            default: '75px'
        },
        group: {     // 是否按职位分组
            type: Boolean,
            default: true
        },
    },
    watch: {
        positionList: {
            immediate: true,
            handler (val) {
                console.log(val)
                this.handlerData();
            }
        }
    },
    methods: {
        handlerData () {
            if (this.group) {
                this.posiList = this.positionList
            } else {
                this.posiList = Object.keys(this.list)
            }
        },
        clickItem (item) {
            this.$emit('click', item);
        },
    }
}
</script>
<style lang='scss' scoped>
.people_position {
    .position_tit {
        font-size: 16px;
        line-height: 22px;
        color: $base-font-major;
    }
    .group {
        display: inline-block;
    }
    .list {
        display: flex;
        flex-wrap: wrap;
        .list_item {
            cursor: pointer;
            display: flex;
            width: 260px;
            margin: 0 24px 16px 0;
            position: relative;
            border-bottom: 1px solid #f3f5f9;
            padding: 11px 16px;
            box-sizing: border-box;
            border-radius: 6px;
            .item_details {
                flex: 1;
            }
            // 球员评估样式
            &.player_item {
                padding: 0 16px;
                align-items: center;
                .time {
                    height: 20px;
                    line-height: 20px;
                }
            }
            &:hover {
                background: linear-gradient(89.86deg, #5581ff 0.01%, #0042e1 99.96%);
                span {
                    color: #fff;
                }
                .time {
                    &.bg {
                        background: rgba(241, 244, 255, 0.1);
                    }
                    .time_icon {
                        color: #fff;
                    }
                }
            }
        }

        .group_position {
            font-size: 12px;
            line-height: 17px;
            height: 17px;
            color: $base-font-minor;
        }

        .position {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 12px;
            color: $base-font-minor;
        }
        .time {
            display: inline-block;
            border-radius: 6px;
            font-size: 14px;
            color: $base-color-theme;
            width: 100px;
            height: 28px;
            line-height: 28px;
            box-sizing: border-box;
            &.bg {
                background: #f1f4ff;
                padding-left: 12px;
            }
            .time_icon {
                color: #81818a;
            }
        }
    }
    // 球员视频报告列表样式
    .player_video {
        .player_list {
            display: flex;
            flex-wrap: wrap;
            .player_item {
                width: 261px;
                height: 75px;
                margin: 0 24px 16px 0;
                padding: 12px 16px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                border-bottom: 1px solid $base-border-color-one;
                cursor: pointer;
                &:hover {
                    border-radius: 6px;
                    background: $base-blue-linear;
                    .number,
                    .player_info,
                    .video_icon,
                    .name,
                    .video_number {
                        color: #fff !important;
                    }
                }
                .player_info {
                    flex: 1;
                    margin-left: 20px;
                    font-size: 16px;
                    color: $base-font-major;
                    .video_number {
                        line-height: 20px;
                        color: $base-color-theme;
                        .video_icon {
                            font-size: 14px;
                            color: #81818a;
                        }
                    }
                }
            }
        }
    }
    .number {
        font-size: 18px;
        color: #81818a;
        margin-right: 16px;
        min-width: 22px;
        text-align: center;
    }
    .name {
        font-size: 16px;
        height: 22px;
        line-height: 22px;
        color: $base-font-major;
    }
}
</style>
